import { getRoute, useLayout } from '@/functions';

export default {
    path: '/',
    component: useLayout('auth'),
    children: [
        getRoute('/login', 'accountsLogin', 'login/login_page', { title: 'Accounts Login' }),
        getRoute('/signup', 'accountsSignup', 'signup/signup_page', { title: 'Accounts Signup' }),
    ],
};